import React, { useState, useEffect } from "react";
import { Tab, Tabs, Typography } from "@mui/material";
import MTSummaryReport from "./SupportCoordinationReports/MTSummaryReport";
import SCVisitReport from "./SupportCoordinationReports/SCVisitReport";
import MTCompletionDetailReport from "./SupportCoordinationReports/MTCompletionDetailReport";
import ManagementReviewReport from "./SupportCoordinationReports/ManagementReviewReport";
import MTRejectionReport from "./SupportCoordinationReports/MTRejectionReport";
import LateMTReport from "./SupportCoordinationReports/LateMTReport";

export default function SupportCoordination_Reports(props) {
    const [activeKey, setActiveKey] = useState("scVisit");

    const isAdmin = props.user.type === 'Admin';

    const handleKeyChange = (event, activeKey) => {
        setActiveKey(activeKey);
    };

    useEffect(() => {
        console.log("Active Sub Key:", props.activeSubKey);
        setActiveKey(props.activeSubKey)
    }, [props.activeSubKey]);

    return (
        <div style={{width: '100%', position: 'absolute'}}>
            <div>
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                        fontFamily: "Lato",
                        marginBottom: 10,
                        marginLeft: 10
                    }}
                >
                    Support Coordination Reports
                </Typography>
            </div>
            <div style={{width: '100%'}}>
                <Tabs
                    value={activeKey}
                    onChange={handleKeyChange}
                    variant="scrollable"
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        '& .Mui-selected': {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                        }
                    }}
                >
                    {props.user.permissions.MTSummaryReport && <Tab key={"mtSummary"} value={"mtSummary"} label="MT Summary" />}
                    {props.user.permissions.VisitReport && <Tab key={"scVisit"} value={"scVisit"} label="Visits" />}
                    {props.user.permissions.MTCompletionDetailReport && <Tab key={"mtCompletionDetail"} value={"mtCompletionDetail"} label="MT Completion Detail" />}
                    {props.user.permissions.ManagementReviewReport && <Tab key={"managementReview"} value={"managementReview"} label="Management Review" />}
                    {props.user.permissions.MTRejectionReport && <Tab key={"mtRejection"} value={"mtRejection"} label="MT Rejection" />}
                    {props.user.permissions.LateMTReport && <Tab key={"lateMT"} value={"lateMT"} label="Late MT" />}
                </Tabs>

                <div style={{width: '100%'}}>
                {activeKey === "mtSummary" && <MTSummaryReport {...props} />}
                {activeKey === "scVisit" && <SCVisitReport {...props} />}
                {activeKey === "mtCompletionDetail" && <MTCompletionDetailReport {...props} />}
                {activeKey === "managementReview" && <ManagementReviewReport {...props} />}
                {activeKey === "mtRejection" && <MTRejectionReport {...props} />}
                {activeKey === "lateMT" && <LateMTReport {...props} />}
                </div>
            </div>
        </div>
    )
};